import { createSyncManager } from '../../lib/sync-manager'
import { createSubscriptionsCollection } from '../../lib/subscriptions'

export default defineNuxtPlugin(() => {
  if (import.meta.server) {
    return
  }

  const collection = createSubscriptionsCollection()
  /**
  const syncManager = createSyncManager()
  syncManager.addCollection(collection, {
    name: 'subscriptions',
  })

  const { status, isAuthenticated } = useAuthLinks()
  watch(status, (newVal, oldVal) => {
    console.debug(
      `[$subscriptions] auth status changed from ${oldVal} to ${newVal}`,
      { status: unref(status), isAuthenticated: unref(isAuthenticated) },
    )

    if (newVal === 'authenticated' && oldVal !== 'authenticated') {
      console.log('[$subscriptions] authenticated, syncing with backend')
      // syncManager.sync('subscriptions')
    }
  })
  */

  return {
    provide: {
      subscriptions: () => ({
        collection,
        // syncManager,
      }),
    },
  }
})

declare module '#app' {
  interface NuxtApp {
    $subscriptions(): {
      collection: ReturnType<typeof createSubscriptionsCollection>
      syncManager: ReturnType<typeof createSyncManager>
    }
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $subscriptions(): {
      collection: ReturnType<typeof createSubscriptionsCollection>
      syncManager: ReturnType<typeof createSyncManager>
    }
  }
}
